export default __webpack_public_path__ + "static/media/contact_plane_down.f99ae057.svg";